import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useFeatureFlags } from '@/hooks/useFeatureFlags'

import ApprovalsHub from './Hub/Index.vue'
import ApprovalsTabs from './ApprovalsTabs.vue'

// Home de /aprovacoes: com a flag ligada é o hub em cards (uma rota por fila,
// ver Hub/queues.ts); desligada, o shell de abas histórico com `?tab=`.

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { flags } = useFeatureFlags()

return (_ctx: any,_cache: any) => {
  return (_unref(flags).enabledApprovalsHub)
    ? (_openBlock(), _createBlock(ApprovalsHub, { key: 0 }))
    : (_openBlock(), _createBlock(ApprovalsTabs, { key: 1 }))
}
}

})